import { render, staticRenderFns } from "./PinRightIcon.vue?vue&type=template&id=365ed709&"
import script from "./PinRightIcon.vue?vue&type=script&lang=js&"
export * from "./PinRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports